import { render, staticRenderFns } from "./InformationArea.vue?vue&type=template&id=2448f8a7&scoped=true&"
import script from "./InformationArea.vue?vue&type=script&lang=js&"
export * from "./InformationArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448f8a7",
  null
  
)

export default component.exports